import { render, staticRenderFns } from "./admin-application-paid2023-show.vue?vue&type=template&id=2d36a84a&scoped=true"
import script from "./admin-application-paid2023-show.vue?vue&type=script&lang=js"
export * from "./admin-application-paid2023-show.vue?vue&type=script&lang=js"
import style0 from "./admin-application-paid2023-show.vue?vue&type=style&index=0&id=2d36a84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36a84a",
  null
  
)

export default component.exports